<template>
  <div>
    <hr class="norm" />
    <div>
      <h3>
        This application uses
        <a href="https://getbootstrap.com/" target="_blank" rel="noopener"
          >Bootstrap</a
        >
      </h3>
      Powerful, extensible, and feature-packed frontend toolkit. Build and
      customize with Sass, utilize prebuilt grid system and components, and
      bring projects to life with powerful JavaScript plugins.
    </div>
  </div>
</template>
